import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'customCalendarDimensionWidth' })
export class CustomCalendarDimensionWidthPipe implements PipeTransform {
  /**
   * Pipe filters the list of rooms-chat based on the search text provided
   *
   * @returns list of rooms filtered by search text or []
   * @param formValues
   * @param event
   * @param type
   */
  transform(
    formValues: any,
    event: any,
    type: string,
    headLess: boolean
  ): string | null {
    const fontSize = parseInt(formValues.fontSize);
    if (
      formValues.includeDimensions &&
      (!event.customContent ||
        (event.customContentType === 'DIMENSIONS' && event.customContent))
    ) {
      return headLess ? fontSize / 0.75 + 'px' : fontSize + 'px';
    }
    return '0';
  }
}
